import React from 'react';

class FanBomMessageRoot extends React.Component {
  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

export default FanBomMessageRoot;




// WEBPACK FOOTER //
// ./src/components/FanBox/FanBomMessageRoot.jsx